module.exports = __webpack_public_path__ + "img/js.1047d828.svg";